import { Component } from '@angular/core'

@Component({
    selector: 'sf-advert-cta-item-title',
    template: `<ng-content></ng-content>`,
    imports: [],
    host: {
        class: 'advert__item-title fw-bold',
    },
})
export class AdvertCtaItemTitleComponent {}
